import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, Form, Input, Label, Button, FormGroup } from "reactstrap";
import FeatherIcon from "feather-icons-react";

class CTA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: "",
        email: "",
        phone: "",
        message: ""
      },
      isSubmitting: false,
      submitSuccess: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    
    // Form gönderme işlemi burada yapılacak
    // Şimdilik sadece başarı mesajı gösteriyoruz
    setTimeout(() => {
      this.setState({ 
        isSubmitting: false, 
        submitSuccess: true,
        formData: {
          name: "",
          email: "",
          phone: "",
          message: ""
        }
      });
      
      setTimeout(() => {
        this.setState({ submitSuccess: false });
      }, 5000);
    }, 1000);
  }

  render() {
    return (
      <React.Fragment>
        <section id="iletisim" className="section bg-light">
          <Container>
            <Row className="justify-content-center">
              <Col lg="10" md="12">
                <div className="text-center mb-5">
                  <h4 className="title mb-3">
                    İletişim
                  </h4>
                </div>

                {/* İletişim Formu */}
                <Row className="justify-content-center mt-4">
                  <Col lg="10" md="12">
                    <Card className="border-0 shadow rounded">
                      <CardBody className="p-4 p-md-5">
                        {this.state.submitSuccess && (
                          <div className="alert alert-success alert-dismissible fade show" role="alert">
                            <i className="uil uil-check-circle me-2"></i>
                            Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                            <button type="button" className="btn-close" onClick={() => this.setState({ submitSuccess: false })}></button>
                          </div>
                        )}

                        <Form onSubmit={this.handleSubmit}>
                          <Row>
                            <Col md="4" className="mt-3">
                              <FormGroup>
                                <Label className="form-label">
                                  Ad Soyad <span className="text-danger">*</span>
                                </Label>
                                <div className="form-icon position-relative">
                                  <FeatherIcon icon="user" className="fea icon-sm icons" />
                                </div>
                                <Input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Adınız ve Soyadınız"
                                  name="name"
                                  value={this.state.formData.name}
                                  onChange={this.handleChange}
                                  required
                                />
                              </FormGroup>
                            </Col>

                            <Col md="4" className="mt-3">
                              <FormGroup>
                                <Label className="form-label">
                                  E-posta <span className="text-danger">*</span>
                                </Label>
                                <div className="form-icon position-relative">
                                  <FeatherIcon icon="mail" className="fea icon-sm icons" />
                                </div>
                                <Input
                                  type="email"
                                  className="form-control ps-5"
                                  placeholder="E-posta adresiniz"
                                  name="email"
                                  value={this.state.formData.email}
                                  onChange={this.handleChange}
                                  required
                                />
                              </FormGroup>
                            </Col>

                            <Col md="4" className="mt-3">
                              <FormGroup>
                                <Label className="form-label">Telefon</Label>
                                <div className="form-icon position-relative">
                                  <FeatherIcon icon="phone" className="fea icon-sm icons" />
                                </div>
                                <Input
                                  type="tel"
                                  className="form-control ps-5"
                                  placeholder="Telefon numaranız"
                                  name="phone"
                                  value={this.state.formData.phone}
                                  onChange={this.handleChange}
                                />
                              </FormGroup>
                            </Col>

                            <Col md="12" className="mt-3">
                              <FormGroup>
                                <Label className="form-label">
                                  Mesaj <span className="text-danger">*</span>
                                </Label>
                                <div className="form-icon position-relative">
                                  <FeatherIcon icon="message-circle" className="fea icon-sm icons" />
                                </div>
                                <Input
                                  type="textarea"
                                  className="form-control ps-5"
                                  placeholder="Mesajınızı buraya yazın..."
                                  name="message"
                                  rows="5"
                                  value={this.state.formData.message}
                                  onChange={this.handleChange}
                                  required
                                />
                              </FormGroup>
                            </Col>

                            <Col md="12" className="mt-3">
                              <div className="d-grid">
                                <Button
                                  color="primary"
                                  type="submit"
                                  className="btn-lg"
                                  disabled={this.state.isSubmitting}
                                >
                                  {this.state.isSubmitting ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      Gönderiliyor...
                                    </>
                                  ) : (
                                    <>
                                      <i className="uil uil-message me-2"></i>
                                      Mesaj Gönder
                                    </>
                                  )}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {/* İletişim Bilgileri */}
                <Row className="justify-content-center mt-5">
                  <Col lg="5" md="6" className="mt-4">
                    <Card className="border-0 shadow rounded text-center h-100" style={{ transition: "all 0.3s ease", cursor: "pointer" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                      }}>
                      <CardBody className="p-4">
                        <div className="icon text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                          style={{ 
                            width: "80px", 
                            height: "80px", 
                            backgroundColor: "rgba(85, 110, 230, 0.1)",
                            transition: "all 0.3s ease"
                          }}>
                          <i className="uil uil-map-marker" style={{ fontSize: "2rem" }}></i>
                  </div>
                        <h5 className="mb-3 fw-bold">Adres</h5>
                        <p className="text-muted mb-0" style={{ lineHeight: "1.8" }}>
                          Tarabya, Sardunya Sk. No:8<br />
                          34457 Sarıyer/İstanbul
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col lg="5" md="6" className="mt-4">
                    <Card className="border-0 shadow rounded text-center h-100" style={{ transition: "all 0.3s ease", cursor: "pointer" }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                      }}>
                      <CardBody className="p-4">
                        <div className="icon text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" 
                          style={{ 
                            width: "80px", 
                            height: "80px", 
                            backgroundColor: "rgba(85, 110, 230, 0.1)",
                            transition: "all 0.3s ease"
                          }}>
                          <i className="uil uil-envelope" style={{ fontSize: "2rem" }}></i>
                </div>
                        <h5 className="mb-3 fw-bold">E-posta</h5>
                        <p className="text-muted mb-0">
                          <a href="mailto:info@dijitalsiramatik.com" 
                            className="text-primary h6 text-decoration-none"
                            style={{ 
                              transition: "all 0.3s ease",
                              fontSize: "1.1rem"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = "#556ee6";
                              e.currentTarget.style.textDecoration = "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = "#556ee6";
                              e.currentTarget.style.textDecoration = "none";
                            }}>
                            info@dijitalsiramatik.com
                          </a>
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default CTA;
